import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GroupsCatalog } from './group-catalogs.models';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EndpointConstants } from 'src/app/core/services/endpoints-configurations/endpoint-constants';
import { ProjectSettingsService } from 'src/app/core/services/common/project-settings.service';

@Injectable({ providedIn: 'root' })
export class GroupCatalogsStoreService {
  options = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey),
  };

  constructor(
    private http: HttpClient,
    private settings: ProjectSettingsService,
  ) {}

  getGroupsCatalog(): Observable<GroupsCatalog[]> {
    const url = this.settings.generateEndpoint(EndpointConstants.ApiGroups);
    return this.http.get<GroupsCatalog[]>(url, this.options);
  }
}
